import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../../connectionString';

@Injectable()
export class PaRegistrationService {

  constructor(private http: HttpClient) { }

  checkUsernameIfExist(username: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Registration/checkUsername?username='+username );
  }

  registerUser(username: string, password: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/PA/Registration/registerPatient', {username: username, password: password })
  }
}
